import { isNotNullish, isNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString } from '../../../../../utils/stringify-utils';
import { AttentionNodeCreateProps } from '../models/attention-node-create-props';
import { AttentionNode } from '../models/attention-node.model';
import { attachAttentionNode } from '../utils/attention-utils';
import { ATTENTION_NODE_PREDICATES } from './../config/part-names';

export const createAttentionNode = (diagram: go.Diagram, { categoryName, location }: AttentionNodeCreateProps) => {
  const key = uuid.v4();
  const { x, y } = location;

  diagram.commit(() => diagram.model.addNodeData(new AttentionNode(key, categoryName, getPointString(x, y))));

  const attentionNode = diagram.findNodeForKey(key);
  autoAttachAttentionNode(attentionNode!, new go.Point(x, y));

  return attentionNode;
};

const autoAttachAttentionNode = (attentionNode: go.Node, location: go.Point) => {
  if (isNullish(attentionNode?.diagram)) {
    return;
  }

  const predicates = ((attentionNode.diagram as unknown as { [ATTENTION_NODE_PREDICATES]: unknown })[
    ATTENTION_NODE_PREDICATES
  ] || []) as Array<(node: go.Node) => boolean>;
  const attachToPart = attentionNode.diagram
    ?.findObjectsAt(
      location,
      (obj: go.GraphObject) => obj.part,
      (obj: go.Part) => obj !== attentionNode && obj instanceof go.Node && predicates.every((p) => p(obj)),
    )
    ?.first()?.part;

  if (isNotNullish(attachToPart)) {
    attachAttentionNode(attachToPart, attentionNode);
  }
};
